import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { QuestionAnswer, TopicAnswers } from '@app/_models';
import { LocationService } from '@app/_services';
import { CourseService } from '@app/_services/course.service';
import { TopicShareService } from '@app/_services/topic.share.service';
import { first } from 'rxjs/operators';

@Component({ 
    selector: 'worksheet',
    templateUrl: 'worksheet.component.html'
})
export class WorksheetComponent {

    constructor(){}
    
    ngOnInit(){
        
    }
}